import React, { useState } from 'react'
import { Tooltip, Modal, ModalHeader, ModalBody, ModalFooter, Button } from 'reactstrap'
import { message } from "antd"
import { deletePriorityStore } from "../../../../services/api/apiReGenerateLabel"

const DeleteStore = ({ tooltipDelete, handleToggleTooltipDelete, item, reload }) => {

    const [isOpen, setIsOpen] = useState(false)
    const [loading, setLoading] = useState(false)
    const [error, setError] = useState('')

    const _handleToggleModal = () => {
        setIsOpen(!isOpen)
    }

    const _handleDelete = async () => {
        setLoading(true)
        setError('')

        try {
            const { data } = await deletePriorityStore(item._id)
            const { success, message: mes } = data

            if (!success) {
                setLoading(false)
                setIsOpen(false)
                return message.error(mes)
            }

            setIsOpen(false)
            message.success('Xóa store thành công!')
            reload()
        } catch (e) {
            setError(e.message)
        }
    }

    return (
        <span title="Xóa">
            <i onClick={_handleToggleModal} className="fa fa-trash fa-lg text-danger" id={`TooltipDelete${item._id}`} />
            <Tooltip placement="top" isOpen={tooltipDelete} target={`TooltipDelete${item._id}`} toggle={handleToggleTooltipDelete}>
                Xóa Store
            </Tooltip>
            {isOpen && <Modal isOpen={isOpen} toggle={_handleToggleModal}>
                <ModalHeader toggle={_handleToggleModal}>Xóa Store</ModalHeader>
                <ModalBody>
                    <span>Bạn có chắc chắn muốn xóa store <strong>{item.namespace}</strong>?</span>
                    {error && <div className="text-danger mt-3">{error}</div>}
                </ModalBody>
                <ModalFooter className="d-flex justify-content-between align-items-center">
                    <Button color="secondary" disabled={loading} onClick={_handleToggleModal}>Hủy</Button>
                    <Button color="primary" disabled={loading} onClick={_handleDelete}>{loading && <i className='fa fa-spin fa-spinner mr-2' />} Xóa</Button>
                </ModalFooter>
            </Modal>}
        </span>
    )
}

export default DeleteStore